import {
  Avatar,
  Box,
  Button,
  FilterOptionsState,
  Stack,
  Typography,
} from '@mui/material';
import { ControlledAutocomplete } from 'Components';
import { DEFAULT_AUTOCOMPLETE_RESULT_LIMIT } from 'Config';
import { TherapySuppliersContext } from 'Context/SuppliersContext/TherapySuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleX } from 'Images';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';

interface ITherapistsName {
  isReset: React.MutableRefObject<boolean>;
}

const TherapistsName = ({ isReset }: ITherapistsName) => {
  const { supplierNames } = useContext(TherapySuppliersContext);
  const { setValue, watch } = useFormContext<ITherapySuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  const handleFilterOptions = (
    options: string[],
    state: FilterOptionsState<string>,
    resultLimit?: number
  ) => {
    if (!state.inputValue.trim()) {
      return [];
    } else {
      const filtered = options.filter((option: string) => {
        return `${option}`.includes(state.inputValue);
      });
      return filtered?.slice(
        0,
        resultLimit || DEFAULT_AUTOCOMPLETE_RESULT_LIMIT
      );
    }
  };

  return !(supplierNames.length > 0) ? (
    <></>
  ) : (
    <Stack
      gap='20px'
      sx={{
        '.MuiOutlinedInput-root': {
          mt: 0,
        },
        '.MuiOutlinedInput-input': { mt: '-10px' },
      }}
    >
      <Typography variant='body2'>{dictionary.therapistsName}</Typography>
      <Box position={'relative'}>
        <ControlledAutocomplete
          filterOptions={handleFilterOptions}
          setValue={(v: string | null) => {
            setValue('supName', v || '');
          }}
          options={supplierNames}
          label={''}
          value={watch('supName')}
          freeSolo
          isSetDataOnInputChange
          placeholder={dictionary.namePlaceholder}
        />
        {!!watch('supName') && (
          <Button
            onClick={() => {
              setValue('supName', '');
              isReset.current = true;
            }}
            sx={{
              height: '40px',
              width: '40px',
              minWidth: '40px',
              position: 'absolute',
              top: '0px',
              right: '4px',
              backgroundColor: 'white',
              zIndex: 1,
            }}
          >
            <Avatar
              alt={dictionary.resetTherapistsName}
              src={PurpleX}
              sx={{ width: '20px', height: '20px' }}
            />
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default TherapistsName;
